import {
  QuestionDto,
  QuestionImageUploadResponse,
  State,
} from "../../interfaces";
import { MediaDto } from "../../interfaces/media";
import { Paginated } from "../../models";
import {
  ADD_QUESTION,
  ADD_QUESTION_ERROR,
  ADD_QUESTION_SUCCESS,
  ActionTypes,
  DELETE_QUESTION,
  DELETE_QUESTION_CONSENT,
  DELETE_QUESTION_ERROR,
  DELETE_QUESTION_SUCCESS,
  GET_QUESTION,
  GET_QUESTIONS_BY_LESSON,
  GET_QUESTIONS_BY_LESSON_ERROR,
  GET_QUESTIONS_BY_LESSON_SUCCESS,
  GET_QUESTION_ERROR,
  GET_QUESTION_SUCCESS,
  TOGGLE_ADD_EDIT_QUESTION_MODAL,
  TOGGLE_QUESTION_STATE,
  TOGGLE_QUESTION_STATE_ERROR,
  TOGGLE_QUESTION_STATE_SUCCESS,
  UPDATE_QUESTION,
  UPDATE_QUESTION_ERROR,
  UPDATE_QUESTION_SUCCESS,
  UPLOAD_QUESTION_DISPLAY_IMAGE,
  UPLOAD_QUESTION_DISPLAY_IMAGE_ERROR,
  UPLOAD_QUESTION_DISPLAY_IMAGE_SUCCESS,
  UPLOAD_QUESTION_IMAGE,
  UPLOAD_QUESTION_IMAGE_ERROR,
  UPLOAD_QUESTION_IMAGE_SUCCESS,
} from "./actionTypes";

export class QuestionState {
  questions!: State<Paginated<QuestionDto>>;
  question!: State<QuestionDto>;
  addQuestion!: State<any>;
  updateQuestion!: State<any>;
  deleteQuestion!: State<any>;
  questionsByLesson!: State<QuestionDto[]>;
  displayImage!: State<File>;
  toggleQuestionState: any;
  questionImage!: State<QuestionImageUploadResponse>;
  constructor() {
    this.questions = {
      loading: false,
      error: null,
      success: false,
    };
    this.question = {
      loading: false,
      error: null,
      success: false,
    };
    this.addQuestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateQuestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteQuestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.questionsByLesson = {
      loading: false,
      error: null,
      success: false,
    };
    this.displayImage = {
      loading: false,
      error: null,
      success: false,
    };
    this.toggleQuestionState = {
      loading: false,
      error: null,
      success: false,
    };
    this.questionImage = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: QuestionState = new QuestionState();

export const question = (
  state: QuestionState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_QUESTIONS_BY_LESSON:
      state = {
        ...state,
        questionsByLesson: {
          ...state.questionsByLesson,
          loading: true,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_QUESTIONS_BY_LESSON_SUCCESS:
      state = {
        ...state,
        questionsByLesson: {
          ...state.questionsByLesson,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_QUESTIONS_BY_LESSON_ERROR:
      state = {
        ...state,
        questionsByLesson: {
          ...state.questionsByLesson,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_QUESTION:
      state = {
        ...state,
        question: {
          ...state.question,
          loading: true,
          success: false,
          error: null,
        },
        addQuestion: {
          ...state.addQuestion,
          loading: false,
          success: false,
          error: null,
        },
        updateQuestion: {
          ...state.updateQuestion,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_QUESTION_SUCCESS:
      state = {
        ...state,
        question: {
          ...state.question,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_QUESTION_ERROR:
      state = {
        ...state,
        question: {
          ...state.question,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_QUESTION:
      state = {
        ...state,
        addQuestion: {
          ...state.addQuestion,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_QUESTION_SUCCESS:
      state = {
        ...state,
        addQuestion: {
          ...state.addQuestion,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case ADD_QUESTION_ERROR:
      state = {
        ...state,
        addQuestion: {
          ...state.addQuestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPDATE_QUESTION:
      state = {
        ...state,
        updateQuestion: {
          ...state.updateQuestion,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_QUESTION_SUCCESS:
      state = {
        ...state,
        updateQuestion: {
          ...state.updateQuestion,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case UPDATE_QUESTION_ERROR:
      state = {
        ...state,
        updateQuestion: {
          ...state.updateQuestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_QUESTION_CONSENT:
      state = {
        ...state,
        deleteQuestion: {
          ...state.deleteQuestion,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_QUESTION:
      state = {
        ...state,
        deleteQuestion: {
          ...state.deleteQuestion,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_QUESTION_SUCCESS:
      state = {
        ...state,
        deleteQuestion: {
          ...state.deleteQuestion,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_QUESTION_ERROR:
      state = {
        ...state,
        deleteQuestion: {
          ...state.deleteQuestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_QUESTION_DISPLAY_IMAGE:
      state = {
        ...state,
        displayImage: {
          ...state.displayImage,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPLOAD_QUESTION_DISPLAY_IMAGE_SUCCESS:
      state = {
        ...state,
        displayImage: {
          ...state.displayImage,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case UPLOAD_QUESTION_DISPLAY_IMAGE_ERROR:
      state = {
        ...state,
        displayImage: {
          ...state.displayImage,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_ADD_EDIT_QUESTION_MODAL:
      state = {
        ...state,
        question: {
          ...state.question,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
        displayImage: {
          ...state.displayImage,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case TOGGLE_QUESTION_STATE:
      state = {
        ...state,
        toggleQuestionState: {
          ...state.toggleQuestionState,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_QUESTION_STATE_SUCCESS:
      state = {
        ...state,
        toggleQuestionState: {
          ...state.toggleQuestionState,
          loading: false,
          error: null,
          success: true,
        },
        questionsByLesson: {
          ...state.questionsByLesson,
          response: state.questionsByLesson?.response?.map(
            (subject: QuestionDto) => {
              if (subject.id === action.payload.id)
                return { ...subject, isActive: !subject.isActive };
              return subject;
            }
          ),
        },
      };
      break;
    case TOGGLE_QUESTION_STATE_ERROR:
      state = {
        ...state,
        toggleQuestionState: {
          ...state.toggleQuestionState,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_QUESTION_IMAGE:
      state = {
        ...state,
        questionImage: {
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPLOAD_QUESTION_IMAGE_SUCCESS:
      state = {
        ...state,
        questionImage: {
          loading: false,
          success: true,
          error: null,
          response: action.payload,
        },
      };
      break;
    case UPLOAD_QUESTION_IMAGE_ERROR:
      state = {
        ...state,
        questionImage: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
